import { VueCookieNext } from "vue-cookie-next";
import { clearAuthCookies, cookieOptions } from "@/core/services/AuthCookies";

const ID_TOKEN_KEY = "_seip_token" as string;

export const getToken = (): string | null => {
  return VueCookieNext.getCookie(ID_TOKEN_KEY);
};

export const saveToken = (token: string): void => {
  VueCookieNext.setCookie(ID_TOKEN_KEY, token, cookieOptions());
};

/**
 * Clears the token together with the rest of the session, using the domain
 * the current host actually writes cookies under. The domain used to be
 * hardcoded, so on any host but that one the token survived sign-out and
 * the user stayed logged in.
 */
export const destroyToken = (): void => {
  clearAuthCookies();
};

export default { getToken, saveToken, destroyToken };
